import { render } from "./OrderSummary.vue?vue&type=template&id=9e0e5036&scoped=true"
import script from "./OrderSummary.vue?vue&type=script&lang=js"
export * from "./OrderSummary.vue?vue&type=script&lang=js"

import "./OrderSummary.vue?vue&type=style&index=0&id=9e0e5036&lang=scss&scoped=true"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal_claud/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e0e5036"]])

export default __exports__